document.addEventListener("DOMContentLoaded", () => {
  function initSwatches(scope = document) {
    scope.querySelectorAll(".product-card").forEach((card) => {
      // Prevent double-binding
      if (card.dataset.swatchesBound === "true") return;

      const imgEl = card.querySelector("img");
      const linkEl = card.querySelector(".product-card__link");
      const swatches = card.querySelectorAll(".swatch");

      // Save fallback (first/default product image)
      const fallbackImage = imgEl ? imgEl.src : "";

      if (swatches.length) {
        swatches.forEach((swatch, index) => {
          swatch.addEventListener("click", (e) => {
            e.preventDefault();

            const newImage = swatch.dataset.image;
            const newUrl = swatch.dataset.url;

            // ✅ Update product image (use fallback if empty)
            if (imgEl) {
              if (newImage && newImage.trim() !== "") {
                imgEl.src = newImage;
                imgEl.srcset = "";
              } else if (fallbackImage) {
                imgEl.src = fallbackImage;
                imgEl.srcset = "";
              }
            }

            // ✅ Update product link
            if (linkEl && newUrl && newUrl.trim() !== "") {
              linkEl.href = newUrl;
            }

            // ✅ Update browser URL
            if (newUrl && newUrl.trim() !== "") {
              window.history.replaceState({}, "", newUrl);
            }

            // ✅ Toggle active state
            swatches.forEach((s) => s.classList.remove("active"));
            swatch.classList.add("active");
          });

          // ✅ On load, auto-activate the first swatch
          if (index === 0) {
            swatch.classList.add("active");
            if (swatch.dataset.image && imgEl) {
              imgEl.src = swatch.dataset.image;
              imgEl.srcset = "";
            }
            if (swatch.dataset.url && linkEl) {
              linkEl.href = swatch.dataset.url;
            }
          }
        });
      }

      // ✅ Adjust swatch margin based on title line count
      function adjustSwatchMargin() {
        const title = card.querySelector(".h4 p");
        const swatchContainer = card.querySelector(".product-card-swatches");

        if (title && swatchContainer) {
          const lineHeight = parseFloat(getComputedStyle(title).lineHeight);
          const lines = Math.round(title.offsetHeight / lineHeight);

          // Detect mobile by screen width
          const isMobile = window.innerWidth <= 768;

          if (lines > 1) {
            swatchContainer.style.marginTop = isMobile ? "-4px" : "-7px";
          } else {
            swatchContainer.style.marginTop = isMobile ? "-7px" : "-10px";
          }
        }
      }

      adjustSwatchMargin();
      window.addEventListener("resize", adjustSwatchMargin);

      // Mark as initialized
      card.dataset.swatchesBound = "true";
    });
  }

  // Run once on page load
  initSwatches();

  // Watch for dynamically added product cards (infinite scroll, load more, etc.)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.matches(".product-card")) {
            initSwatches(node.parentNode || node);
          } else if (node.querySelectorAll) {
            const newCards = node.querySelectorAll(".product-card");
            if (newCards.length) {
              initSwatches(node);
            }
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});